import React from "react";

export const StatusPill = ({ status, t }) => {
  const map = {
    pending: { bg: "bg-orange-50", text: "text-orange-700", label: t("s_pending") },
    assigned: { bg: "bg-blue-50", text: "text-blue-700", label: t("s_assigned") },
    out_for_delivery: { bg: "bg-violet-50", text: "text-violet-700", label: t("s_out_for_delivery") },
    delivered: { bg: "bg-green-50", text: "text-green-700", label: t("s_delivered") },
    cancelled: { bg: "bg-red-50", text: "text-red-700", label: t("s_cancelled") },
  };
  const s = map[status] || { bg: "bg-gray-100", text: "text-gray-700", label: status };
  return <span className={`pill ${s.bg} ${s.text}`}>{s.label}</span>;
};

export const PaymentPill = ({ method, status, t }) => {
  const labels = {
    paid: { cls: "bg-green-50 text-green-700", label: t("paid") },
    upi_pending: { cls: "bg-amber-50 text-amber-700", label: t("upi_pending") },
    cash_to_collect: { cls: "bg-rose-50 text-rose-700", label: t("cash_to_collect") },
  };
  const s = labels[status] || { cls: "bg-gray-100 text-gray-700", label: status };
  return (
    <span className={`pill ${s.cls}`}>
      {method === "upi" ? "UPI" : t("cash")} • {s.label}
    </span>
  );
};

export default StatusPill;
